<template>
	<div class="tableWrap">
		<div class="head">
			<span @click="goBack" class="back">
				<i>&nbsp;</i>返回</span>
			<span class="mx">BU罚单明细</span>
			<p class="select">
				<el-date-picker class="top-choose" v-model="datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
				</el-date-picker>
				<small>~</small>
				<el-date-picker class="top-choose" v-model="datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
				</el-date-picker>
				<span>罚单类型：</span>
				<el-select class="top-choose" v-model="typeId" clearable placeholder="请选择">
					<el-option v-for="item in ticket_type" :key="item.id"  :value="item.id" :label="item.ticket_name" >
					</el-option>
				</el-select>
				<el-button type="primary" style="margin-left:20px;" @click="search()" >查询</el-button>
			</p>
		</div>

		<div class="table-main">
			<div class="main-head">
				<div>罚单编号</div>
				<div>罚单日期</div>
				<div>周期</div>
				<div>罚单类型</div>
				<div>金额(币)</div>
				<div>处罚原因</div>
			</div>
			<z-scrollDiv class="main-wrap">
				<div class="main-item" v-for="item in dataList" :key="item.id">
					<div>{{ item.code }}</div>
					<div>{{ item.created_at | justDate }}</div>
					<div>{{ item | cycleStr }}</div>
					<div>{{ item.ticket_name }}</div>
					<div>{{ item.currency_name+item.ticket_amount }}</div>
					<div class="overhide" :title="item.remark">{{ item.remark }}</div>
				</div>
				<z-noData :list="dataList"></z-noData>
			</z-scrollDiv>
		</div>

		<z-pagination @getPage="search" :data='data'></z-pagination>
	</div>
</template>

 <script type="text/ecmascript-6">
	import { mapGetters,mapState } from 'vuex'
	export default {
		data() {
			return {
				// year:"",
				// cycleId:"",
				datePick_start:"",
				datePick_end:"",
				typeId:"",  //选项 罚单类型
				data:{},  //罚单数据
				ticket_type:[],  //罚单类型
			}
		},
		computed: {
			...mapState(["picker_special"]),
			dataList(){
				return this.data.list;
			},
		},

		created(){
			this.refresh();

			let url = `api/clerk/cfg_ticket/bu`;  //罚单类型
			this.$http.get(url).then(res=>{
				if(res.status == 200){
					this.ticket_type = res.res_data;
				}
			});
		},

		methods: {
			goBack: function () {
				this.$router.push({
					name:'info-money',
				});
			},
			refresh(obj={}){   //获取bu罚单数据
				this.$http.get("api/manager/ticket_detail",{params:obj}).then(res=>{
					if(res.status == 200){
						this.data = res.res_data;
					}
				}).catch(error=>{

				});
			},
			search(page){  //带参数
				let config = {
					page:page,
					start_date:this.datePick_start,
					end_date:this.datePick_end,
					ticket_category_id:this.typeId,
				};
				this.refresh(config);
			},
			// shareCycle(item){  //奖金周期获取 拼接
			// 	let share_cycle = this.BonusCycleObj[item.cycle_detail_id];
			// 	return `${share_cycle.cycle_name}(${share_cycle.distribute_text})`;
			// },
			// ticketTypeText(id){  //罚单类型 拼接
			// 	let res = "";
			// 	this.buTicket.some(item=>{
			// 		return item.id == id && (res = item.ticket_name);
			// 	});
			// 	return res;
			// },
		},

	}
</script>

<style lang="less" scoped>
	@import "~src/assets/less/asset-detail.less";
	// **************
	.main-head,.main-item{
		>div{
			&:nth-of-type(1){
				width:12%;
			}
			&:nth-of-type(2){
				width:12%;
				// text-align: center;
			}
			&:nth-of-type(3){
				width:13%;
				// text-align: center;
			}
			&:nth-of-type(4){
				width: 13%;
				// text-align: center;
			}
			&:nth-of-type(5){
				width: 12%;
			}
			&:nth-of-type(6){
				max-width: 38%;
			}
			
		}
	}
</style>





// WEBPACK FOOTER //
// page-ticketTable.vue?7939917c